import Section from '../Section';
import Parallax from '../global/Parallax';

export default class CollectionList extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.parallax = new Parallax(theme, element.parentNode);
    this.theme.addBadges(this.element, 1000);
  }
}
